import { getDownloadURL, getStorage, ref, uploadBytes, uploadString } from "firebase/storage";
import { useEffect, useState } from "react";

// the firebase reference to storage
const storage = getStorage();

const FirebaseFileUploadApi = () => {
    // the data from the file upload response
    const [dataResponse, setDataResponse] = useState();

    // sets properties on the file to be uploaded
    const [fileData, setFileData] = useState();

    // if we are loading a file or not
    const [isLoading, setIsLoading] = useState(false);

    // this function will be called when the any properties in the dependency array changes
    useEffect(() => {
        /**
         *
         * @param _value
         */
        const setUp = (_value) => {
            if (_value instanceof File) {
                let fName = `${new Date().getTime()}-${_value.name}`;
                // setting the firebase properties for the file upload
                let imageRef = ref(storage, "images/" + fName);
                // return imageRef.put(_value);
                return uploadBytes(imageRef, _value)
            } else {
                let v = _value;
                let fName = `${new Date().getTime()}.${v.format}`;
                // setting the firebase properties for the file upload
                let imageRef = ref(storage, "images/" + fName);
                // return imageRef.putString(v.dataUrl, "data_url");
                return uploadString(imageRef, v.dataUrl, 'data_url');
            }
        };

        const uploadData = async () => {
            // initialize upload information
            setIsLoading(true);

            // handle a file upload or a dataUrl upload
            setUp(fileData).then(
                async (snapshot) => {
                    // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
                    let downloadUrl = await getDownloadURL(snapshot.ref);
                    setDataResponse({
                        downloadUrl
                    });
                    setIsLoading(false)
                }
            );
        }

        fileData && uploadData();
    }, [fileData]);

    return [
        { dataResponse, isLoading },
        setFileData
    ];
}

export default FirebaseFileUploadApi;